import React from 'react';
import { Container, Accordion, Row, Col } from 'react-bootstrap';
import { FaExclamationTriangle, FaHandPaper, FaBan, FaBalanceScale, FaFileAlt } from 'react-icons/fa';
import {
  PageContainer,
  PageHeader,
  InfoCard,
  AccordionScenario,
  AnimatedSection,
  accordionStyles
} from '../../../components/SharedComponents';

const scenarios = [
  {
    id: 1,
    icon: <FaHandPaper />,
    title: 'W odpowiedzi na groźbę rozwiązania umowy z powodu L4',
    color: '#667eea',
    threat: 'Jeśli będziesz tak chorować, to rozwiążę umowę o naukę zawodu, bo potrzebuję pracownika, nie chorego.',
    response: 'Rozumiem Pana/Pani frustrację, ale choroba jest czymś niezależnym ode mnie. Grożenie mi zwolnieniem z powodu wykorzystania usprawiedliwionego zwolnienia lekarskiego (L4) jest niezgodne z prawem. Umowa o pracę w celu przygotowania zawodowego podlega takiej samej ochronie, jak każda inna umowa. L4 jest prawnie usprawiedliwioną nieobecnością, a jej wykorzystanie nie może być podstawą do rozwiązania umowy.'
  },
  {
    id: 2,
    icon: <FaBan />,
    title: 'W odpowiedzi na żądanie odpracowania L4 w sobotę',
    color: '#f093fb',
    threat: 'Skoro byłeś/aś na L4, to masz przyjść w sobotę i odpracować te dni. To zaległości w szkoleniu.',
    response: 'Zwolnienie lekarskie (L4) to płatna, usprawiedliwiona nieobecność w pracy. Prawo pracy nie przewiduje obowiązku odpracowania dni nieobecności spowodowanej chorobą. Co więcej, zgodnie z Art. 203 § 3 Kodeksu pracy, jako pracownik młodociany, przysługuje mi 48 godzin nieprzerwanego odpoczynku tygodniowego, obejmującego niedzielę. Przychodząc w sobotę, złamałbym/ałabym ten przepis. Nie mogę się na to zgodzić.'
  },
  {
    id: 3,
    icon: <FaBalanceScale />,
    title: 'W odpowiedzi na kwestię niższego wynagrodzenia (80%) i "podwójnej kary"',
    color: '#4facfe',
    threat: 'Dostajesz 80% wynagrodzenia za L4, więc musisz coś w zamian oddać, żeby to się wyrównało.',
    response: 'Obniżenie wynagrodzenia do 80% za czas L4 nie jest karą, lecz regulacją prawną, a jednocześnie jest to rekompensata za to, że nie mogłem/mogłam świadczyć pracy. W związku z tym nie ma mowy o żadnym \'odpracowywaniu\' tej nieobecności. Prawo pracy zabrania podwójnego \'karania\' pracownika, czyli zarówno pomniejszenia pensji, jak i wymuszania pracy w dni wolne.'
  },
  {
    id: 4,
    icon: <FaFileAlt />,
    title: 'Formalna odpowiedź na pisemne polecenie odpracowania',
    color: '#43e97b',
    threat: 'Pracodawca wydaje formalne polecenie lub wysyła e-mail z nakazem przyjścia w sobotę.',
    response: 'Szanowny/a Panie/Pani [Nazwisko], informuję, że odpracowanie dni nieobecności z powodu zwolnienia lekarskiego jest niezgodne z Kodeksem pracy. Zwolnienie lekarskie stanowi usprawiedliwioną nieobecność, która jest zaliczana do stażu pracy. Ponadto przypominam, że jako młodociany pracownik mam bezwzględny zakaz pracy w soboty (naruszenie 48h odpoczynku tygodniowego – Art. 203 § 3 KP). Proszę o natychmiastowe wycofanie tego bezprawnego polecenia.'
  },
  {
    id: 5,
    icon: <FaExclamationTriangle />,
    title: 'Przy stanowczym nacisku i powołanie się na ochronę prawną',
    color: '#f5576c',
    threat: 'Albo przyjdziesz w sobotę, albo będzie rozmowa u dyrektora. Nie zgadzam się na Twoje wymówki.',
    response: 'Rozumiem, że Pana/Pani oczekiwania są inne, ale ja muszę przestrzegać prawa, które mnie chroni. Moja odmowa pracy w sobotę jest spowodowana bezwzględnym przepisem chroniącym młodocianych przed pracą w dni wolne, a próba zmuszenia mnie do odpracowania L4 jest złamaniem podstawowych praw pracowniczych. Jeśli Pana/Pani groźby będą kontynuowane, będę zmuszony/a zgłosić to naruszenie do Państwowej Inspekcji Pracy (PIP), która zajmuje się nadzorem nad prawami młodocianych.'
  }
];

const SickLeave = () => {
  return (
    <PageContainer>
      <Container>
        <style>{accordionStyles}</style>
        
        <PageHeader 
          title="L4 - Zwolnienie lekarskie"
          subtitle="Szablony rozmów przy zgłaszaniu zwolnienia lekarskiego"
        />

        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <AnimatedSection>
              <InfoCard>
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                  Zwolnienie lekarskie (L4) jest prawnie usprawiedliwioną nieobecnością w pracy. Nie musisz go 
                  odpracowywać, a pracodawca nie może Cię ukarać za korzystanie z L4. Poniżej znajdziesz gotowe 
                  szablony odpowiedzi na różne sytuacje.
                </p>
              </InfoCard>
            </AnimatedSection>

            <Accordion alwaysOpen>
              {scenarios.map((scenario, index) => (
                <AccordionScenario
                  key={scenario.id}
                  scenario={scenario}
                  index={index}
                  eventKey={String(index)}
                  argumentLabel="Groźba/Żądanie pracodawcy"
                  responseLabel="Asertywna odpowiedź"
                  argumentField="threat"
                />
              ))}
            </Accordion>

            <AnimatedSection delay={0.6} className="mt-4">
              <InfoCard
                gradient="rgba(255, 0, 0, 0.1)"
                borderColor="rgba(255, 0, 0, 0.3)"
                icon={<FaExclamationTriangle style={{ color: '#ff0000' }} />}
                title="Pamiętaj"
              >
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                  W przypadku pracownika młodocianego przepisy Kodeksu pracy są szczególnie restrykcyjne. Masz prawo 
                  do L4 i nie musisz go odpracowywać. Groźba zwolnienia z powodu choroby lub żądanie odpracowania L4 
                  jest bezprawne. W takiej sytuacji, po udzieleniu asertywnej odpowiedzi, warto rozważyć konsultację 
                  z Państwową Inspekcją Pracy (PIP).
                </p>
              </InfoCard>
            </AnimatedSection>
          </Col>
        </Row>
      </Container>
    </PageContainer>
  );
};

export default SickLeave;